
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, FileText, BarChart2, FileUp, User } from 'lucide-react';
import { Button } from '@/components/ui/button';

type NavItem = {
  name: string;
  icon: React.ReactNode;
  path: string;
};

const SidebarNavigation = () => {
  const navigate = useNavigate();
  
  const navItems: NavItem[] = [
    { name: 'Dashboard', icon: <Home size={20} />, path: '/dashboard' },
    { name: 'Upphandlingar', icon: <FileText size={20} />, path: '/procurements' },
    { name: 'Analyser', icon: <BarChart2 size={20} />, path: '/analyses' },
    { name: 'Ny upphandling', icon: <FileUp size={20} />, path: '/new-procurement' },
    { name: 'Min profil', icon: <User size={20} />, path: '/profile' },
  ];

  return (
    <nav className="flex-1 px-4 py-4">
      <ul className="space-y-1">
        {navItems.map((item) => (
          <li key={item.path}>
            <Button
              variant="ghost"
              className={`w-full justify-start text-left ${
                window.location.pathname === item.path
                  ? 'bg-yellow-50 text-accent'
                  : ''
              }`}
              onClick={() => navigate(item.path)}
            >
              {item.icon}
              <span className="ml-3">{item.name}</span>
            </Button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SidebarNavigation;
